import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { useStore } from '@/store';
import { getDeviceGroupNew } from '@/service/production/equipmentLive';
export default function useGoupListNew() {
  var store = useStore();
  var deviceGroup = ref([]);
  var loading = ref(true);
  var curSiderbarIndex = computed(function () {
    return store.state.production.curSiderbarIndex;
  });
  // 获取主机汇总数据
  var getDeviceGroupAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            loading.value = true;
            _context.next = 4;
            return getDeviceGroupNew();
          case 4:
            data = _context.sent;
            deviceGroup.value = data.list;
            //如果原先的选中菜单的id和现在的不一样，则说明切换厂区了,要注意考虑不同厂区的菜单列表长度不一致，原菜单当前选中索引有可能超现在的列表长度
            // 需要考虑切换后的厂区左侧菜单项的数据和切换前的厂区左侧菜单项的数量长度不同
            // 1.切换后的厂区左侧菜单项比切换前的厂区左侧菜单项的数量多
            // 2.切换后的厂区左侧菜单项比切换前的厂区左侧菜单项的数量少
            // if (
            //   store.state.production.siderbar.length !== res.data.list.length ||
            //   store.state.production.siderbar[curSiderbarIndex.value].groupNo !==
            //     res.data.list[curSiderbarIndex.value]?.groupNo
            // )
            if (!data.list.filter(function (item) {
              return item.groupNo;
            }).map(function (item) {
              return item.groupNo;
            }).includes(store.state.production.curSiderbarId)) {
              // 有可能是切换厂区了，也有可能是没切换厂区，只是菜单列表被操作用在后台修改了（增删改）,设备列表当前选中菜单索引置零
              store.commit('production/updateSiderbarIndex', 0);
              store.commit('production/updateSiderbarId', undefined);
              // store.commit('production/updateSiderbar', [])
              store.commit('production/updateSiderbar', data.list);
            } else {
              // 没有切换厂区
              store.commit('production/updateSiderbar', data.list);
              store.commit('production/updateSiderbarId', data.list[curSiderbarIndex.value].groupNo);
            }
            loading.value = false;
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            loading.value = false;
            console.log(_context.t0);
          case 14:
            _context.prev = 14;
            console.log('finally');
            return _context.finish(14);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10, 14, 17]]);
    }));
    return function getDeviceGroupAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [deviceGroup, loading, getDeviceGroupAsync];
}